import API from "@/api/lib/api";

export const getAllAddOns = async (restaurant_id, menu_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/add-ons/${menu_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleAddOnsById = async (id) => {
  try {
    const response = await API.get(`restaurant/add-ons/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createAddOns = async (data) => {
  try {
    const response = await API.post(`restaurant/add-ons`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateAddOns = async (id, data) => {
  try {
    const response = await API.put(`restaurant/add-ons/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const deleteAddOns = async (id) => {
  try {
    const response = await API.delete(`restaurant/add-ons/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};